import '../../node_modules/owl.carousel/dist/owl.carousel.min';
import '../../node_modules/select2/dist/js/select2.min.js';
import '../../node_modules/magnific-popup/dist/jquery.magnific-popup.js';
import '../../node_modules/jquery-lazy/jquery.lazy';
require('../../node_modules/jquery-mousewheel/jquery.mousewheel.js');
require('../../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js');

let $body = $('body');
const defaultSetting = {
    loop: false,
    nav: true,
    autoHeight: true,
    dots: true,
    lazyLoad: true,
    items: 1
};
export let ui;
ui = {
    initSlider(el, settings = defaultSetting) {
        $(el).owlCarousel(settings).on('changed.owl.carousel')
        setTimeout(() => {
            let $dots = $(el).find('.owl-dots')
            $dots.insertAfter($(el).find('.owl-prev'))
        }, 200)
    },

    /**
     * Lazy load image
     */
    initLazyLoadImg() {
        $('.js_lazy-img-bg').lazy()
        $('.js_lazy-img').lazy({
            effect:'fadeIn'
        })
    },

    /**
     * Scroll to the top of the site
     *
     * @param el - button which you click on to scroll up.
     */

    addScrollClass(el){
        $(window).scroll(function() {
            if ($(window).scrollTop() > 50) {
                $(el).fadeIn(400)
            }
            else{
                $(el).fadeOut(400)
            }
        })
        $body.on('click', el, function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $body.offset().top - 100
            }, 500)
        })
    },

    /**
     * Init select2
     * @param el
     */
    initDefaultSelect(el) {
        $(el).each(function(){
            let $thisSelect = $(this)
            $thisSelect.select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $thisSelect.parent()
            }).on('select2:open', () => {
                $('.select2-results__options').mCustomScrollbar('destroy')
                setTimeout(() => {
                    $('.select2-results__options').mCustomScrollbar()
                }, 0)
            })
        })
    },

    /**
     * Open popup
     *@param el - class of the element
     */
    popupForm(el) {
        $body.on('click', el, function(e) {
            e.preventDefault()
            let $el = $(this)
            let modalEL = $el.attr('href')
            ui.openPopup(modalEL)
        })
    },

    /**
     * Open popup
     * @param modalEL
     */
    openPopup(modalEL) {
        $.magnificPopup.open({
            showCloseBtn: false,
            type: 'inline',
            tLoading: 'Загрузка...',
            items: {
                src: modalEL
            }
        })
    },

    /**
     * Close popup
     * @param el
     */
    closePopup(el) {
        $body.on('click', el, function(e) {
            e.preventDefault();
            $.magnificPopup.close()
        })
    },

    /**
     * Style scroll
     * @param el
     */
    initScrollStyle(el) {
        if($(el).length === 0) return
        $(el).mCustomScrollbar({
            theme: 'dark',
            advanced:{
                updateOnContentResize: true,
            }
        });
    },
};
